import React from 'react';
import { Card } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useStoreState } from '../store';

export const AccessDenied = () => {
  const loading = useStoreState((state) => state.loading.pageLoading);
  const message = (
    <span>
      <WarningOutlined style={{ fontSize: '23px', marginRight: '10px' }} />
      Access Denied
    </span>
  );
  return (
    <Card title={message} loading={loading}>
      <p>Insufficient permissions to access this page.</p>
    </Card>
  );
};

export default AccessDenied;
